import * as React from 'react';
import { Props as CloseButtonProps } from './index';
import { observer } from 'mobx-react';

interface Props extends CloseButtonProps {
  circleColor?: string;
  fontColor?: string;
  displayAfter?: number;
  elapsedTime?: number;
  offsetY?: number;
  isViewable?: boolean;
  timerTick?: number;
}

let rendered = false;
let currentAnimationFrame: number | null = null;
let animationDuration: string | null = null;

export const CountdownCloseButton = observer((props: Props) => {
  const {
    iconSize = 15,
    circleColor = '#C1C1C1',
    fontColor = '#C1C1C1',
    style,
    displayAfter = 3,
    elapsedTime = 0,
    offsetY = 0,
    isViewable = false,
    timerTick = 3
  } = props;
  const countdownLineSize: number = 1.5;
  const countdownRadius: number = Math.floor(
    (iconSize - countdownLineSize) / 2
  );
  const countdownPerimeter: number = Math.floor(2 * Math.PI * countdownRadius);

  if (!currentAnimationFrame) {
    currentAnimationFrame = countdownPerimeter;
  }

  if (!animationDuration) {
    animationDuration = `${displayAfter}s`;
  }

  const svgPosition: React.CSSProperties = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: iconSize,
    height: iconSize,
    transform: 'rotateZ(-90deg)'
  };

  const showCountdown = displayAfter > elapsedTime;
  if (isViewable && !rendered) {
    rendered = true;
  }

  if (!isViewable && rendered && showCountdown) {
    currentAnimationFrame = Math.round(
      countdownPerimeter - (countdownPerimeter / displayAfter) * elapsedTime
    );
    animationDuration = `${displayAfter - elapsedTime}s`;
    rendered = false;
  }

  return (
    <>
      {isViewable && (
        <div
          style={{
            position: 'relative',
            height: iconSize,
            width: iconSize,
            marginTop: offsetY,
            ...style
          }}
          data-zone="countdown_close_button"
        >
          <div style={{ height: iconSize, width: iconSize }}>
            <div
              style={{
                color: fontColor,
                lineHeight: `${iconSize}px`,
                textAlign: 'center'
              }}
              data-zone="countdown_timer_tick"
            >
              {timerTick}
            </div>
            <svg style={svgPosition}>
              <circle
                r={countdownRadius}
                cx="50%"
                cy="50%"
                stroke={circleColor}
                strokeWidth={countdownLineSize}
                fill="none"
                strokeDasharray={countdownPerimeter}
              >
                <animate
                  attributeName="stroke-dashoffset"
                  from={currentAnimationFrame}
                  to="0"
                  dur={animationDuration}
                  repeatCount="indefinite"
                />
              </circle>
            </svg>
          </div>
        </div>
      )}
    </>
  );
});
